import { useMemo } from 'react';

import useCoursePathEvaluation from '@/data/hook/evaluation/useCoursePathEvaluation';
import useMasterEvaluations from '@/data/hook/evaluation/useMasterEvaluations';
import { ORDENABLE_PAGE_SIZE } from '@/constants';
import { Assessment } from '@/models/Assessment';

type UseCoursePathAssessmentsProps = {
  coursePathId: number;
  courseLineId: number;
};

const useCoursePathAssessments = ({
  coursePathId,
  courseLineId,
}: UseCoursePathAssessmentsProps) => {
  const { evaluations: masters, isLoading: isMastersLoading } =
    useMasterEvaluations({ courseLineId, pageSize: ORDENABLE_PAGE_SIZE });

  const { evaluation, isLoading: isEvaluationLoading } = useCoursePathEvaluation(
    { courseLineId, coursePathId, masters },
  );

  const assessments = useMemo<Assessment[]>(
    () => evaluation?.assessments ?? [],
    [evaluation],
  );

  return {
    assessments,
    isLoading: isMastersLoading || isEvaluationLoading,
  };
};

export default useCoursePathAssessments;
